import React from "react";
import Banner from "./Banner";

function Videos() {
  return (
    <div id="Videos">
      <hr></hr>
      {/* Bibliotheca Iulia instaurata short [already there]
        Frederic Nolan Clark on Renaissance reading
        Tracy Cosgriff on Raphael’s portraits of books (coming soon)
        Andreas Kratky on designing the Bibliotheca Iulia Instaurata (coming soon)
        Lisa Pon on the Stanza della Segnatura as library */}
      <section className=" media">
        <iframe
          src="https://www.youtube.com/embed/tJ8Kt441bDA?si=n5p3_aW3_YeKsvJV"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
        <div className="PlaceHolder"></div>
      </section>
      <section className="media">
        {/* <iframe
          src="https://drive.google.com/file/d/1b0nTRMbTRx6wRpewckZQ9z_n6HprTeh0/preview "
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe> */}
         {/* video updated Mar */}
         <iframe
          src="https://drive.google.com/file/d/1Ehb017CV_ijt6NymPPQd0sWs-bR7V0vG/preview "
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
        <div className="PlaceHolder"></div>
      </section>

      <section className="content">
        {/* <img src={wall} alt='wall'/> */}
        <Banner />
      </section>
    </div>
  );
}

export default Videos;
